import { useState } from 'react';
import { getDesktop } from '@/desktop/desktop';
import { PencilIcon } from '@components/icons';

/**
 * SKJV Desktop only — where user data lives on disk (PRD §5a settable
 * root). Changing it migrates existing data (copy, never clobber) and
 * reloads the app pointed at the new folder.
 */
export function DataFolderSection() {
  const desktop = getDesktop();
  const [isChanging, setIsChanging] = useState(false);
  if (!desktop) return null;

  const change = async () => {
    const picked = await desktop.pickDirectory();
    if (!picked || picked === desktop.storageRoot) return;
    setIsChanging(true);
    const settings = desktop.settings ?? { inference: { source: 'local' as const } };
    await desktop.saveSettings({ ...settings, storageRoot: picked });
    window.location.reload();
  };

  return (
    <section data-testid="data-folder-section">
      <h2 className="mb-2 text-lg font-semibold text-stone-800 dark:text-stone-200">Data Folder</h2>
      <p className="mb-2 text-xs text-stone-500 dark:text-stone-400">
        Your studies and personal data live here as plain files — keep it somewhere your backups cover.
      </p>
      <div className="mb-3 break-all rounded-xl bg-stone-100/50 p-3 text-xs text-stone-600 dark:bg-stone-800/30 dark:text-stone-400" data-testid="data-folder-path">
        {desktop.storageRoot}
      </div>
      <button
        onClick={change}
        disabled={isChanging}
        className="flex items-center gap-2 rounded-lg bg-cyan-500 px-4 py-2 text-white transition-colors hover:bg-cyan-600 disabled:opacity-50"
      >
        <PencilIcon className="h-4 w-4" />
        {isChanging ? 'Moving…' : 'Change folder…'}
      </button>
    </section>
  );
}
